export function getBaseUrl(path: string) {
  if (path.includes('/organizations/')) {
    return '/organizations';
  } else if (path.includes('/peoples/')) {
    return '/peoples';
  } else if (path.includes('/board/project/')) {
    return '/board';
  } else if (path.includes('project-template/')) {
    return '/project-template';
  } else if (path.includes('/marketing-board/board/')) {
    return '/marketing-board';
  } else if (path.includes('/support-tickets/detail/') || path.includes('/support-tickets/')) {
    return '/support-tickets';
  } else if (path.includes('/project-template/')) {
    return '/project-template';
  } else if (path.includes('/media/')) {
    return '/media';
  } else if (path.includes('/dashboard/')) {
    return '/dashboard';
  } else if (path.includes('/project/')) {
    return '/board';
  } else if (path.includes('/course/') || path.includes('/courses/')) {
    return '/courses';
  } else if (path.includes('/glossary/')) {
    return '/glossary';
  } else if (path.includes('/line-up/')) {
    return '/line-up';
  } else if (path.includes('/library/')) {
    return '/library';
  } else if (path.includes('/checklists/')) {
    return '/checklists';
  } else if (path.includes('/todos/')) {
    return '/todos';
  } else if (path.includes('/reports/')) {
    return '/reports';
  } else if (path.includes('/support-tickets/')) {
    return '/support-tickets';
  } else if (path.includes('/time-materials/')) {
    return '/time-materials';
  } else if (path.includes('/orders/')) {
    return '/orders';
  } else if (path.includes('/subscription-board/')) {
    return '/subscription-board';
  } else if (path.includes('/project-template/')) {
    return '/project-template';
  } else if (path.includes('/proposals/')) {
    return '/proposals';
  } else if (path.includes('/project-template/')) {
    return '/project-template';
  }
  return path;
}
